module.exports = __webpack_public_path__ + "img/ic-help-toc-glight.56a2b846.svg";